import React from "react";
import { Box, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";

interface Props {
  esEmpresa: boolean;
  onChange: (esEmpresa: boolean) => void;
  disabled?: boolean;
}

/**
 * Lo primero que se decide al cargar un titular: persona o empresa. Va antes
 * de los campos del nombre para que el formulario ya muestre lo que
 * corresponde cuando se empieza a escribir.
 */
const TipoClienteSelector: React.FC<Props> = ({ esEmpresa, onChange, disabled }) => (
  <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
    <Typography
      variant="caption"
      color="text.secondary"
      sx={{ fontSize: { xs: "0.72rem", sm: "0.75rem" } }}
      id="tipo-cliente-label"
    >
      Titular
    </Typography>
    <ToggleButtonGroup
      exclusive
      fullWidth
      size="small"
      value={esEmpresa ? "empresa" : "persona"}
      onChange={(_, valor: "persona" | "empresa" | null) => {
        if (valor) onChange(valor === "empresa");
      }}
      disabled={disabled}
      aria-labelledby="tipo-cliente-label"
      sx={{
        "& .MuiToggleButton-root": {
          flex: 1,
          py: 0.25,
          fontSize: { xs: "0.8rem", sm: "0.85rem" },
          textTransform: "none",
          border: "1px solid",
          borderColor: "divider",
          height: { xs: 34, sm: 32 },
          "&.Mui-selected": {
            bgcolor: "primary.main",
            color: "primary.contrastText",
            "&:hover": { bgcolor: "primary.dark" },
          },
        },
      }}
    >
      <ToggleButton value="persona">Persona</ToggleButton>
      <ToggleButton value="empresa">Empresa</ToggleButton>
    </ToggleButtonGroup>
  </Box>
);

export default TipoClienteSelector;
